'use client';

/**
 * Board Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { UserPlus, Layers, Award, RefreshCw } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.boardPlan.hero"
                imageSrc="/images/mlm-plans/Board_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.boardPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.boardPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.boardPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.boardPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6']}
                gridCols="3"
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.boardPlan.commissions"
                commissions={[
                    { icon: UserPlus, color: 'primary', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                    { icon: Layers, color: 'blue', titleKey: 'level.title', descriptionKey: 'level.description' },
                    { icon: Award, color: 'green', titleKey: 'boardCompletion.title', descriptionKey: 'boardCompletion.description' },
                    { icon: RefreshCw, color: 'purple', titleKey: 'reEntry.title', descriptionKey: 'reEntry.description' },
                ]}
                gridCols="2"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.boardPlan.whySoftware" />
        </div>
    );
}

